import { useEffect } from "react";

const SITE_URL = "https://smoothfinishdrywallrepair.ca";
const SITE_NAME = "Smooth Finish Drywall Repairs";
const DEFAULT_OG_IMAGE =
  "https://images.unsplash.com/photo-1768839725085-829e6ac7ac26?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let tag = document.head.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
}

/**
 * useSeo: sets per-page title/description/canonical and OG/Twitter tags.
 * @param {{title?:string, description?:string, path?:string, image?:string}} opts
 */
export default function useSeo({ title, description, path = "/", image = DEFAULT_OG_IMAGE } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    const canonical = `${SITE_URL}${path}`;

    document.title = fullTitle;
    setMeta("description", description);
    setLink("canonical", canonical);

    // Open Graph
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", description, "property");
    setMeta("og:url", canonical, "property");
    setMeta("og:image", image, "property");
    setMeta("og:type", "website", "property");

    // Twitter
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", description);
    setMeta("twitter:image", image);
  }, [title, description, path, image]);
}

export { SITE_URL, SITE_NAME };
